import React from 'react';
import { type RestModalEmailSuccessModal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import { EmailSuccessActions } from './sections/email-success-actions';
import ModalTitle from './sections/title';

type Props = {
  modal: RestModalEmailSuccessModal;
  onClick: Function;
  hide: React.MouseEventHandler;
};

export const EmailModalSuccess: React.FC<Props> = (props) => {
  const {
    modal: { requires },
    onClick,
    hide,
  } = props;

  const handleSubmit = (extra: { excludeOfferAccepts?: boolean }) => {
    onClick(requires.forwards, extra);
  };

  return (
    <div className="email-modal">
      <ModalTitle info={requires.info} />
      <div>
        <div className="success-message">
          <div className="success-title">
            <CustomerHtml value={requires.success.title} />
          </div>
          <div>
            <CustomerHtml value={requires.success.details} />
          </div>
        </div>
      </div>
      <EmailSuccessActions
        info={requires.forwards}
        onClick={handleSubmit}
        hide={hide}
        hideCancel={requires.hideCancel === true}
      />
    </div>
  );
};

EmailModalSuccess.closeBtnFill = '#9d9d9d';
